export default __webpack_public_path__ + "static/w2-d4d942bcfef07bffd6040091d6cc1798.jpg";